export const siteSettings = {
  name: "Alphaex Markets",
  link: "https://alphatradexmarkets.com",
  email: "support@alphatradexmarkets.com",
  appLink: "https://app.alphatradexmarkets.com",
};
